import { render, staticRenderFns } from "./psyTestDetail.vue?vue&type=template&id=e7a64b52&scoped=true&"
import script from "./psyTestDetail.vue?vue&type=script&lang=js&"
export * from "./psyTestDetail.vue?vue&type=script&lang=js&"
import style0 from "./psyTestDetail.vue?vue&type=style&index=0&id=e7a64b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a64b52",
  null
  
)

export default component.exports